export default function () {
    const banner = document.getElementById('countdown')

    if (!banner) return

    const timestamp = banner.getAttribute('data-timestamp')

    // based on milliseconds
    const second = 1000
    const minute = second * 60
    const hour = minute * 60
    const day = hour * 24

    const countDown = new Date(timestamp).getTime()
    const x = setInterval(function () {
        const now = new Date().getTime()
        const distance = countDown - now

        document.getElementById('countdown-days').innerText = Math.floor(distance / day)
        document.getElementById('countdown-hours').innerText = Math.floor((distance % day) / hour)
        document.getElementById('countdown-minutes').innerText = Math.floor((distance % hour) / minute)
        document.getElementById('countdown-seconds').innerText = Math.floor((distance % minute) / second)

        if (distance < 0) {
            document.getElementById('countdown').style.display = 'none'
            clearInterval(x)
        }
    }, 1000) // milliseconds, so 1 second
}
